// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `menu.feed-menu__menu {
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 10px;
}
.feed-menu a.header {
    padding: 10px;
    font-size: 18px;
}
.feed-menu a.header:hover {
    background-color: var(--primary-color-light);
    border-radius: 10px;
}
.feed-menu a.header svg {
    width: 22px;
    margin-right: 5px;
    margin-bottom: -5px;
    color: var(--icon-color);
}
.feed-menu a.header:link,
.feed-menu a.header:visited,
.feed-menu a.header:active {
    display: block;
    padding: 10px;
    color: var(--primary-color-darkest);
}
menu.feed-menu__menu li {
    font-size: 14px;
    padding: 5px 0 5px 10px;
}
menu.feed-menu__menu li svg {
    width: 1.2em;
    height: 1.2em;
    margin-bottom: -0.2em;

}
menu.feed-menu__menu li img {
    width: 1.2em;
    height: 1.2em;
}
menu.feed-menu__menu li a:link,
menu.feed-menu__menu li a:visited,
menu.feed-menu__menu li a:active {
    color: var(--primary-color-darkest);
}
menu.feed-menu__menu li a:hover {
    color: var(--primary-color-dark);
}

menu.feed-menu__menu a.active {
    font-weight: bold;
}
menu.feed-menu__menu li.view-more {
    text-align: center;
}


.groups-feed-menu__pages {
    display: flex;
}
.groups-feed-menu__pages a {
    flex-grow: 1;
    align-self: center;
    justify-self: center;
    text-align: center;
}
.groups-feed-menu__pages a.disabled:link,
.groups-feed-menu__pages a.disabled:visited,
.groups-feed-menu__pages a.disabled:active,
.groups-feed-menu__pages a.disabled:hover {
    color: var(--primary-color-light);
}


.feed-menu__sub-menu menu {
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 10px;
}
.feed-menu__sub-menu a.header {
    padding: 10px;
    font-size: 18px;
}
.feed-menu__sub-menu a.header:hover {
    background-color: var(--primary-color-light);
    border-radius: 10px;
}
.feed-menu__sub-menu a.header svg {
    width: 22px;
    margin-right: 5px;
    margin-bottom: -5px;
    color: var(--icon-color);
}
.feed-menu__sub-menu a.header:link,
.feed-menu__sub-menu a.header:visited,
.feed-menu__sub-menu a.header:active {
    display: block;
    padding: 10px;
    color: var(--primary-color-darkest);
}
.feed-menu__sub-menu menu li {
    font-size: 14px;
    padding: 5px 0 5px 10px;
}
.feed-menu__sub-menu menu li svg,
.feed-menu__sub-menu menu li img {
    width: 1.2em;
    height: 1.2em;
}
.feed-menu__sub-menu menu li a:link,
.feed-menu__sub-menu menu li a:visited,
.feed-menu__sub-menu menu li a:active {
    color: var(--primary-color-darkest);
}
.feed-menu__sub-menu menu li a:hover {
    color: var(--primary-color-dark);
}
.feed-menu__sub-menu menu a.active {
    font-weight: bold;
}
.feed-menu__sub-menu menu li.view-more {
    text-align: center;
}

@media (width <= 1220px) {
    menu.feed-menu__menu {
        text-align: center;
    }

    menu.feed-menu__menu li {
        display: inline-block;
    }
    
    menu.feed-menu__menu .nav-text {
        display: block;
        font-size: 10px;
    }

    .feed-menu__sub-menu {
        display: flex;
        flex-direction: column;
        align-items: center;

        width: 100%;

        margin: 10px 0;
        padding: 10px 0;

        font-size: 18px;
        line-height: 1.7em;

        background-color: white;
        border-top: thin solid var(--main-border-color);
        border-bottom: thin solid var(--main-border-color);
    }
}

`, "",{"version":3,"sources":["webpack://./client/components/feeds/menu/FeedMenu.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;;;IAGI,cAAc;IACd,aAAa;IACb,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;;AAEzB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;;;IAGI,mCAAmC;AACvC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;;AAGA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;;;;IAII,iCAAiC;AACrC;;;AAGA;IACI,qBAAqB;IACrB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;;;IAGI,cAAc;IACd,aAAa;IACb,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;;IAEI,YAAY;IACZ,aAAa;AACjB;AACA;;;IAGI,mCAAmC;AACvC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;;QAEnB,WAAW;;QAEX,cAAc;QACd,eAAe;;QAEf,eAAe;QACf,kBAAkB;;QAElB,uBAAuB;QACvB,+CAA+C;QAC/C,kDAAkD;IACtD;AACJ","sourcesContent":["menu.feed-menu__menu {\n    list-style-type: none;\n    margin: 0;\n    padding: 0 0 0 10px;\n}\n.feed-menu a.header {\n    padding: 10px;\n    font-size: 18px;\n}\n.feed-menu a.header:hover {\n    background-color: var(--primary-color-light);\n    border-radius: 10px;\n}\n.feed-menu a.header svg {\n    width: 22px;\n    margin-right: 5px;\n    margin-bottom: -5px;\n    color: var(--icon-color);\n}\n.feed-menu a.header:link,\n.feed-menu a.header:visited,\n.feed-menu a.header:active {\n    display: block;\n    padding: 10px;\n    color: var(--primary-color-darkest);\n}\nmenu.feed-menu__menu li {\n    font-size: 14px;\n    padding: 5px 0 5px 10px;\n}\nmenu.feed-menu__menu li svg {\n    width: 1.2em;\n    height: 1.2em;\n    margin-bottom: -0.2em;\n\n}\nmenu.feed-menu__menu li img {\n    width: 1.2em;\n    height: 1.2em;\n}\nmenu.feed-menu__menu li a:link,\nmenu.feed-menu__menu li a:visited,\nmenu.feed-menu__menu li a:active {\n    color: var(--primary-color-darkest);\n}\nmenu.feed-menu__menu li a:hover {\n    color: var(--primary-color-dark);\n}\n\nmenu.feed-menu__menu a.active {\n    font-weight: bold;\n}\nmenu.feed-menu__menu li.view-more {\n    text-align: center;\n}\n\n\n.groups-feed-menu__pages {\n    display: flex;\n}\n.groups-feed-menu__pages a {\n    flex-grow: 1;\n    align-self: center;\n    justify-self: center;\n    text-align: center;\n}\n.groups-feed-menu__pages a.disabled:link,\n.groups-feed-menu__pages a.disabled:visited,\n.groups-feed-menu__pages a.disabled:active,\n.groups-feed-menu__pages a.disabled:hover {\n    color: var(--primary-color-light);\n}\n\n\n.feed-menu__sub-menu menu {\n    list-style-type: none;\n    margin: 0;\n    padding: 0 0 0 10px;\n}\n.feed-menu__sub-menu a.header {\n    padding: 10px;\n    font-size: 18px;\n}\n.feed-menu__sub-menu a.header:hover {\n    background-color: var(--primary-color-light);\n    border-radius: 10px;\n}\n.feed-menu__sub-menu a.header svg {\n    width: 22px;\n    margin-right: 5px;\n    margin-bottom: -5px;\n    color: var(--icon-color);\n}\n.feed-menu__sub-menu a.header:link,\n.feed-menu__sub-menu a.header:visited,\n.feed-menu__sub-menu a.header:active {\n    display: block;\n    padding: 10px;\n    color: var(--primary-color-darkest);\n}\n.feed-menu__sub-menu menu li {\n    font-size: 14px;\n    padding: 5px 0 5px 10px;\n}\n.feed-menu__sub-menu menu li svg,\n.feed-menu__sub-menu menu li img {\n    width: 1.2em;\n    height: 1.2em;\n}\n.feed-menu__sub-menu menu li a:link,\n.feed-menu__sub-menu menu li a:visited,\n.feed-menu__sub-menu menu li a:active {\n    color: var(--primary-color-darkest);\n}\n.feed-menu__sub-menu menu li a:hover {\n    color: var(--primary-color-dark);\n}\n.feed-menu__sub-menu menu a.active {\n    font-weight: bold;\n}\n.feed-menu__sub-menu menu li.view-more {\n    text-align: center;\n}\n\n@media (width <= 1220px) {\n    menu.feed-menu__menu {\n        text-align: center;\n    }\n\n    menu.feed-menu__menu li {\n        display: inline-block;\n    }\n    \n    menu.feed-menu__menu .nav-text {\n        display: block;\n        font-size: 10px;\n    }\n\n    .feed-menu__sub-menu {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        width: 100%;\n\n        margin: 10px 0;\n        padding: 10px 0;\n\n        font-size: 18px;\n        line-height: 1.7em;\n\n        background-color: white;\n        border-top: thin solid var(--main-border-color);\n        border-bottom: thin solid var(--main-border-color);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
